export default "__VITE_ASSET__YJjbEO25__"